<template>
    <div>
        <div class="bg-dark text-white py-5 mb-5">
            <div class="container">
                <h1 class="text-white" v-text="$t(`${error.statusCode === 503 ? 'maintenance_mode' : 'error_page'}.heading`)" />
            </div>
        </div>
        <div class="container">
            <div v-html="$t(`${error.statusCode === 503 ? 'maintenance_mode' : 'error_page'}.text`)" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: Object,
            required: true,
        },
    },
};
</script>
